import { render, staticRenderFns } from "./CombinedJobWeekDisplay.vue?vue&type=template&id=f8f85f06&"
import script from "./CombinedJobWeekDisplay.vue?vue&type=script&lang=js&"
export * from "./CombinedJobWeekDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports